import { memo, useRef, useState } from 'react'

import cn from 'classnames'
import styles from './styles.module.scss'

import { ReactComponent as CloseIcon } from '../../../assets/icons/close-white.svg'
import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg'
import { ReactComponent as TelegramIcon } from '../../../assets/icons/telegram.svg'
import { ReactComponent as TrashIcon } from '../../../assets/icons/trashIcon.svg'
import { ReactComponent as ViberIcon } from '../../../assets/icons/viber.svg'
import { ReactComponent as WhatsAppIcon } from '../../../assets/icons/whatsapp.svg'

import Spinner from '../../../UI/Spinner/Spinner'
import Switcher from '../../../UI/Switcher/Switcher'
import UseSmartTooltip from '../../../hooks/useSmartTooltip'

const MESSENGERS_ICONS = [
  { name: 'viber', icon: ViberIcon },
  { name: 'telegram', icon: TelegramIcon },
  { name: 'whatsapp', icon: WhatsAppIcon },
]

const MyContactGroupItem = memo(({ data, onDelete, onEdit, setMain, isActive, isLoading, isSwiped, onSwipeChange }) => {
  const [uncontrolledIsSwiped, setUncontrolledIsSwiped] = useState(false)
  const isSwipedValue = typeof isSwiped === 'boolean' ? isSwiped : uncontrolledIsSwiped
  const swipeRef = useRef({
    startX: 0,
    startY: 0,
    pointerId: null,
    isTracking: false,
    isHorizontal: false,
  })

  const isInteractiveTarget = (target) => {
    if (!target?.closest) return false
    return Boolean(target.closest('button, a, input, label, textarea, select'))
  }

  const handlePointerDown = (e) => {
    if (isInteractiveTarget(e.target)) return

    swipeRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      pointerId: e.pointerId,
      isTracking: true,
      isHorizontal: false,
    }

    try {
      e.currentTarget.setPointerCapture(e.pointerId)
    } catch (_) {
      // ignore
    }
  }

  const handlePointerMove = (e) => {
    const st = swipeRef.current
    if (!st.isTracking || st.pointerId !== e.pointerId) return

    const dx = e.clientX - st.startX
    const dy = e.clientY - st.startY

    if (!st.isHorizontal) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return
      st.isHorizontal = Math.abs(dx) > Math.abs(dy)
    }

    if (st.isHorizontal) {
      e.preventDefault()
    }
  }

  const handlePointerEnd = (e) => {
    const st = swipeRef.current
    if (!st.isTracking || st.pointerId !== e.pointerId) return

    const dx = e.clientX - st.startX
    const dy = e.clientY - st.startY

    if (Math.abs(dx) > Math.abs(dy)) {
      if (dx < -40) {
        if (typeof onSwipeChange === 'function') onSwipeChange(true)
        else setUncontrolledIsSwiped(true)
      }
      if (dx > 30) {
        if (typeof onSwipeChange === 'function') onSwipeChange(false)
        else setUncontrolledIsSwiped(false)
      }
    }

    swipeRef.current.isTracking = false
    swipeRef.current.pointerId = null
  }

  const isGeneralMail = data.id === null && data.header[0] === 'email'
  const isToggleActive = data.is_main || isGeneralMail
  return (
    <>
      <div
        className={cn(styles.card, { [styles.active]: isActive, [styles.swiped]: isSwipedValue })}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerEnd}
        onPointerCancel={handlePointerEnd}
      >
        <div className={styles.cardInfo}>
          <div className={styles.contactType}>{data?.header?.map((type) => type)}</div>

          {setMain && (
            <div className={styles.isMain}>
              {data.id !== null ? 'Main' : <span className={styles.isGeneral}>General</span>}

              {data.id !== null && <Switcher onClick={setMain} id={data.id} isActive={isToggleActive} />}
            </div>
          )}

          <UseSmartTooltip
            className={cn(styles.contact, {
              [styles.messengers]: data?.messengers?.length > 0,
            })}
            tagType={'a'}
            typeLink={data?.header[0] === 'email' ? 'email' : data?.header[0] === 'phone' ? 'tel' : 'a'}
            amount_of_line={1}
            children={data.contact}
          />

          {data?.header[0] === 'phone' && data?.messengers?.length > 0 && (
            <div className={styles.contactMessengers}>
              {data.messengers.map((item) => {
                return MESSENGERS_ICONS.map(({ name, icon: Icon }) => item === name && <Icon key={name} />)
              })}
            </div>
          )}
        </div>
        {data.id !== 'null' && (
          <>
            <div className={styles.cardControls}>
              <button
                className={cn(styles.cardControl, styles.cardControlEdit)}
                onClick={() => onEdit(data.id, isActive)}
              >
                {isActive ? <CloseIcon /> : <EditIcon />}
              </button>

              <button
                className={cn(styles.cardControl, styles.cardControlDelete)}
                onClick={() => onDelete(data.id, isActive)}
              >
                <TrashIcon />
              </button>
            </div>
          </>
        )}
      </div>

      {isLoading && <Spinner size={50} borderColor='rgba(189, 189, 189, 0.47)' />}
    </>
  )
})

export default MyContactGroupItem
